import React from 'react';

import { useNavigate } from 'react-router-dom';
import { HelpArticleContent, HelpFeedback, HelpNodeDetails, HelpToc } from '@ergeon/help-components';

import { authService } from 'common/auth';

import { WIKI_API_HOST, WIKI_DOMAIN, WIKI_LEVEL } from '../constants';
import { WikiNode } from '../types';

import { Heading, TOC_TITLE, describeCount } from './headings';
import LocalSearchForm from './LocalSearchForm';
import MobileDisclosure from './MobileDisclosure';
import NodeError from './NodeError';
import NodeHeader from './NodeHeader';
import NodeSkeleton from './NodeSkeleton';

type NodeBodyProps = {
  headings: Heading[];
  helpNode: { isLoading: boolean; node: WikiNode | null; reload: () => void };
};

const NodeBody = ({ headings, helpNode }: NodeBodyProps) => {
  const navigate = useNavigate();
  const { isLoading, node, reload } = helpNode;

  if (isLoading) {
    return <NodeSkeleton />;
  }
  if (!node) {
    return <NodeError onRetry={reload} />;
  }

  return (
    <>
      {headings.length > 0 && (
        <MobileDisclosure className="xl:hidden" count={describeCount(headings.length, 'section')} title={TOC_TITLE}>
          <HelpToc headings={headings} title={TOC_TITLE} />
        </MobileDisclosure>
      )}
      <article className="flex flex-col gap-6">
        <NodeHeader node={node} />
        <HelpArticleContent content={node.content} onNavigate={navigate} title={node.title} />
      </article>
      <div className="flex flex-col gap-6 border-t border-gray-200 pt-6 xl:hidden dark:border-gray-800">
        <HelpNodeDetails apiHost={WIKI_API_HOST} isPrivate node={node} />
        <LocalSearchForm nodeKey={node.nodeKey} />
      </div>
      <HelpFeedback
        apiHost={WIKI_API_HOST}
        auth={authService}
        className="border-t border-gray-200 pt-6 dark:border-gray-800"
        domain={WIKI_DOMAIN}
        level={WIKI_LEVEL}
        nodeId={node.id} />
    </>
  );
};

export default NodeBody;
